import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { Text } from "@pentabd/ui";

export const SectionTitle = ({
  label,
  size = "md",
  noBorder,
}: {
  label: string;
  size?: "sm" | "md" | "lg" | "xl";
  noBorder?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Text
      weight="semibold"
      color="title"
      component="p"
      size={size}
      className={classNames({ "border-bottom py-8 mb-8": !noBorder })}
    >
      {t(label)}
    </Text>
  );
};
